function PillPlaceholder() {
    return (
        <div className={"animate-pulse hidden lg:hidden xl:block bg-blue-gray-200 h-6 p-1 px-2 w-16 rounded-full"}/>
    );
}

export default PillPlaceholder;
